// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-container {
  width: min(520px, 92vw);
  padding: 30px;
  background: linear-gradient(180deg, #0f172a, #020617);
  border-radius: 18px;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.6);
  border: 1px solid #1e293b;
}

.edit-container h2 {
  text-align: center;
  margin-bottom: 25px;
  color: #ffffff;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.edit-container input {
  width: 100%;
  padding: 12px;
  margin-bottom: 15px;
  border-radius: 8px;
  border: 1px solid #334155;
  background: #0b1220;
  color: #fff;
  font-size: 14px;
  transition: 0.3s;
}

.edit-container input:focus {
  border-color: #22c55e;
  outline: none;
  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.2);
}

.edit-container button {
  width: 100%;
  background: #22c55e;
  color: white;
  border: none;
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  transition: 0.3s;
}

.edit-container button:hover {
  background: #16a34a;
  transform: translateY(-1px);
}

.button-close{
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
}

.edit-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(6px);
  z-index: 1000;
}

.edit-container label {
  display: block;
  margin-bottom: 6px;
  color: #cbd5f5;
  font-size: 13px;
}

.meta-label {
  color: #94a3b8;
  margin-bottom: 12px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Masters/metal_purity_karat/Editmetal_purity_karat/Editmetal_purity_karat.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,aAAa;EACb,qDAAqD;EACrD,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".edit-container {\n  width: min(520px, 92vw);\n  padding: 30px;\n  background: linear-gradient(180deg, #0f172a, #020617);\n  border-radius: 18px;\n  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.6);\n  border: 1px solid #1e293b;\n}\n\n.edit-container h2 {\n  text-align: center;\n  margin-bottom: 25px;\n  color: #ffffff;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n}\n\n.edit-container input {\n  width: 100%;\n  padding: 12px;\n  margin-bottom: 15px;\n  border-radius: 8px;\n  border: 1px solid #334155;\n  background: #0b1220;\n  color: #fff;\n  font-size: 14px;\n  transition: 0.3s;\n}\n\n.edit-container input:focus {\n  border-color: #22c55e;\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.2);\n}\n\n.edit-container button {\n  width: 100%;\n  background: #22c55e;\n  color: white;\n  border: none;\n  padding: 12px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: 0.3s;\n}\n\n.edit-container button:hover {\n  background: #16a34a;\n  transform: translateY(-1px);\n}\n\n.button-close{\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 20px;\n}\n\n.edit-overlay {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(15, 23, 42, 0.55);\n  backdrop-filter: blur(6px);\n  z-index: 1000;\n}\n\n.edit-container label {\n  display: block;\n  margin-bottom: 6px;\n  color: #cbd5f5;\n  font-size: 13px;\n}\n\n.meta-label {\n  color: #94a3b8;\n  margin-bottom: 12px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
